import Button from 'components/helpers/Button';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { defaultSearchHitDataLayerHandler } from '../util';

type HeadlineProps = HitProps & React.HTMLAttributes<HTMLElement>;

export const ProductHitHeadline = ({ hit, children }: HeadlineProps) => {
  const hasLink = !!hit.url;
  const headlineClass = classnames(
    { 'text-gray-brightGray': !hasLink, 'text-blue': hasLink },
    'leading-4',
    'mb-2',
    'line-clamp-3',
    'sm:leading-6',
    'md:line-clamp-2',
    'text-body'
  );

  const publicUrl = process.env.PUBLIC_URL as string;

  // If URL is in the same domain, make it a relative url and ensure only a single leading slash
  const href = hit.url?.startsWith(publicUrl)
    ? hit.url?.replace(publicUrl, '/').replace(/^\/*/, '/')
    : hit.url;

  return (
    <h3 className={headlineClass}>
      {hasLink ? (
        <Button
          linkField={{ value: { href: href } }}
          variant="link"
          suppressLinkText="true"
          onGtmPush={(props) => defaultSearchHitDataLayerHandler({ ...props, hit })}
        >
          {children}
        </Button>
      ) : (
        <>{children}</>
      )}
    </h3>
  );
};
